import React, {Component} from 'react';
import moment from 'moment';
import {DateField, MultiplePhoneField, MultipleEmailType, MultipleEmergencyContact} from '../../commons/Inputs';

let $ = window.jQuery;

export default class FormCommonFields extends Component {
	
	state = {
		entry_date : moment().format('MMMM DD, YYYY'),
		firstname : '',
		middlename : '',
		lastname : '',
		gender : '',
		civil_status : '',
		birthdate : moment().format('MMMM DD, YYYY'),
		religion_id : '',

		// contact_no : '',
		// contact_type : '',
		// email_address : '',
		// email_type : '',

		phone_numbers: [{
            'number':'',
            'phone_type_id': 1
        }],
        email_addresses: [{'email':'',email_type_id : 1}],
        emergency_contact: [{
        	firstname: '',
        	lastname: '',
        	emergency_phones: [{contact_no: ''}],
        }]
	}

	componentDidMount() {
		$('.phoneMask').inputmask("text", {
			mask: '(9999) 999-9999',
			autoUnmask: true,
			oncomplete : (e) => {
				this.setState({contact_no : e.target.value},
					() => {
						this.throwState()
					});
			}
		})
	}

	shouldComponentUpdate(nextProps, nextState) {
		return true;
	}

	componentWillReceiveProps(nextProps) {
		let data = nextProps.data;
		let propsData = {
			entry_date : data.entry_date,
			firstname : data.firstname,
			middlename : data.middlename,
			lastname : data.lastname,
			gender : data.gender,
			civil_status : data.civil_status ? data.civil_status : '',
			birthdate : moment(data.birthdate).format('MMMM DD, YYYY'),
			religion_id : data.religion_id ? data.religion_id : '',
			phone_numbers : data.contact_no,
			email_addresses : data.email_address
			
		}
		if(data.emergency_contacts.length > 0) {
			
			propsData.emergency_contact = data.emergency_contacts
			
		} 
		this.setState(propsData,() => {
			// console.log(this.state)
		});
		
		// this.setState({entry_date : nextProps.data});
	}

	throwState = () => {
		// console.log(this.state)
		this.props.getState(this.state);
	}

	handlePhones = (e) => {
		e.preventDefault();
        let element = $(e.target);

        if(element.hasClass('addPhone')) {
            if(element.parents('.perContainer').find('.phoneInput').val().trim() === '') {
                element.parents('.perContainer').find('.phoneInput').focus();
                return false;
            }

            element.attr('class',' fa fa-times removePhone');

            let phoneInputs = {
                'number': '',
                'phone_type_id': 1
            };
            let phone_numbers = this.state.phone_numbers;
            phone_numbers.push(phoneInputs);

            this.setState({
                phone_numbers
            })

        } else if(element.hasClass('removePhone')) {
            let index = element.parents('.perContainer')[0].dataset.index;

            let phone_numbers = this.state.phone_numbers;
            phone_numbers.splice(index, 1);

            this.setState({
                phone_numbers
            })
        }
	}

	updatePhoneArray = (index, number, phone_type_id) => {
		let phone_numbers = this.state.phone_numbers;
        phone_numbers[index] = {
            number, phone_type_id
        }
        this.setState({
            phone_numbers
        })
	}

	// handleEmails = (e) => {
 //        e.preventDefault();
 //        let element = $(e.target);

 //        if(element.hasClass('addEmail')) {
 //            if(element.parents('.perContainer').find('.emailInput').val().trim() === '') {
 //                element.parents('.perContainer').find('.emailInput').focus();
 //                return false;
 //            }

 //            element.attr('class',' fa fa-times removeEmail');

 //            let emailInputs = '';
 //            let email_addresses = this.state.email_addresses;
 //            email_addresses.push(emailInputs);

 //            this.setState({
 //                email_addresses
 //            })

 //        } else if(element.hasClass('removeEmail')) {
 //            let index = element.parents('.perContainer')[0].dataset.index;

 //            let email_addresses = this.state.email_addresses;
 //            email_addresses.splice(index, 1);

 //            this.setState({
 //                email_addresses
 //            })
 //        }
 //    }

 	addToEmailArray = (state, index) => {
 		let email_addresses = this.state.email_addresses;
 		
 		if(state) // add
 		{
	 		let emailInputs = {email : '',email_type_id : 1};
	 		email_addresses.push(emailInputs);
	 		this.setState({email_addresses});	

	 		return;
 		}
 		
 		// remove
 		email_addresses.splice(index, 1);
 		this.setState({email_addresses});
 	}

    updateEmailArray = (val, index, emailType) => {
        let email_addresses = this.state.email_addresses;
        email_addresses[index] = {email : val,email_type_id : emailType};
        this.setState({
            email_addresses
        })
    }

    updateEmergencyArray = (val, index, inputName) => {
    	let emergency_contact = this.state.emergency_contact
    	emergency_contact[index] = val
    	this.setState({
            emergency_contact
        })
    }

    addToEmergencyArray = (state, index) => {
    	let emergency_contact = this.state.emergency_contact
    	if(state) // add
 		{
	 		let emergencyInput = {
	        	firstname: '',
	        	lastname: '',
	        	emergency_phones: [{contact_no: ''}]
	        };
	 		emergency_contact.push(emergencyInput);
	 		this.setState({emergency_contact});	

	 		return;
 		}

 		// remove
 		emergency_contact.splice(index, 1);
 		this.setState({emergency_contact});
    }

	render() {
		// console.log(this.state.phone_numbers)
		return (
			<div>
				<div className="form-group">
					<div className="row">
						<div className="col-md-4">
							<DateField val={this.state.entry_date} readonly={true} id="entry_date" label="Entry Date *" help="" onChange={(e) => {this.setState({entry_date : e.target.value},() => {this.throwState()})}}/>
		                </div>
					</div>
				</div>
                <div className="form-group">
                	<div className="row">
	                	<div className="col-md-4">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" placeholder="" id="firstname_field" name="firstname" className="form-control" required value={this.state.firstname} onChange={(e) => {this.setState({firstname : e.target.value},() => {this.throwState()})}} />
			                    <label htmlFor="firstname_field" className="control-label">First Name <span className="required" aria-required="true">*</span></label>
			                    <span className="help-block">required...</span>
		                    </div>
	                    </div>
		                <div className="col-md-4">
			                <div className="form-group form-md-line-input">
			                    <input type="text" placeholder="" name="middlename" className="form-control" value={this.state.middlename} onChange={(e) => {this.setState({middlename : e.target.value},() => {this.throwState()})}} /> 
			                    <label className="control-label">Middle Name</label>
			                </div>
		                </div>
		                <div className="col-md-4">
			                <div className="form-group form-md-line-input">
	                    		<input type="text" placeholder="" id="lastname_field" name="lastname" className="form-control" value={this.state.lastname} onChange={(e) => {this.setState({lastname : e.target.value},() => {this.throwState()})}} /> 
			                    <label className="control-label">Last Name <span className="required" aria-required="true">*</span></label>
			                    <span className="help-block">required...</span>
			                </div>
		                </div>
		            </div>
	            </div>
                <div className="form-group">
	                <div className="row">
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<select name="gender" className="form-control" id="gender_field" value={this.state.gender} onChange={(e) => {this.setState({gender : e.target.value},() => {this.throwState()})}}>
	                                <option value="1">Male</option>
	                                <option value="0">Female</option>
	                            </select>
			                    <label className="control-label" name="gender">Gender <span className="required" aria-required="true">*</span></label>
			                    <span className="help-block">required...</span>
			                </div>
		                </div>
		                <div className="col-md-6">
			                <div className="form-group form-md-line-input">
		                		<select className="form-control" name="civil_status" id="civil_status_field" value={this.state.civil_status} onChange={(e) => {this.setState({civil_status : e.target.value},() => {this.throwState()})}}>
	                                <option value="">Select...</option>
	                                <option value="single">Single</option>
	                                <option value="married">Married</option>
	                                <option value="separated">Separated</option>
	                                <option value="widowed">Widowed</option>
	                            </select>
			                    <label className="control-label">Civil Status <span className="required" aria-required="true">*</span></label>
			                    <span className="help-block">required...</span>
			                </div>
		                </div>
		            </div>    
	            </div>  
	            <div className="form-group">
	            	<div className="row">
	                	<div className="col-md-6">
		                	<DateField val={this.state.birthdate} readonly={true} id="birthdate" label="Birth Date *" help="required" onChange={(e) => {this.setState({birthdate : e.target.value},() => {this.throwState()})}}/>
		                </div>
		                <div className="col-md-6">
			                <div className="form-group form-md-line-input">
		                		<select className="form-control" name="religion_id" value={this.state.religion_id} onChange={(e) => {this.setState({religion_id : e.target.value},() => {this.throwState()})}}>
						            <option value="">Select...</option>
									<option value="1">Roman Catholic</option>
									<option value="2">Christian</option>
									<option value="3">Iglesia ni Cristo</option>
									<option value="4">Mormon</option>
									<option value="5">Muslim</option>
									<option value="6">Buddhist</option>
									<option value="7">Agnostic</option>
									<option value="8">Others</option>
								</select>
			                    <label className="control-label">Religion</label>
			                </div>
		                </div>
		            </div> 
	            </div>  
	            <hr/>
	            <div className="form-group">
		            <div className="row">
	                	<div className="col-md-12">
	                		<label><strong>CONTACT</strong></label>
	                	</div>
	                </div>
	                <div className="row">
	                	<div className="col-md-6 parent_content" onClick={this.handlePhones}>
		                	{this.state.phone_numbers.map((phone, i) => {
	                            return <MultiplePhoneField 
	                            				key={i} 
	                            				index={i} 
	                            				totalIndex={this.state.phone_numbers.length}
	                                            val={phone.number} 
	                                            phoneType={phone.phone_type_id}
	                                            numberId={"phone_numbers[" +i+ "][number]"} 
	                                            typeId={"phone_numbers[" +i+ "][type]"} 
	                                            label="Number" 
	                                            help="Phone" 
	                                            type="text"
	                                            updatePhoneArray={this.updatePhoneArray} />
	                        })}
	                	</div>
	                	<div className="col-md-6">
	                		{this.state.email_addresses.map((email, i) => {
                                return <MultipleEmailType key={i} index={i} totalIndex={this.state.email_addresses.length}
                                                val={email.email} emailName={'email_addresses[' + i + '][emailAddress]'} typeName={'email_addresses[' + i + '][type]'} label="Email" help="Email" emailType={email.email_type_id}
                                                updateEmailArray={this.updateEmailArray} addToArray={this.addToEmailArray} />
                            })}
	                	</div>
	                </div>
	                <div className="row">
	                	<div className="col-md-12">
	                		<label><strong>EMERGENCY CONTACT</strong></label>
	                	</div>
	                </div>
	                <div className="row">
	                	<div className="col-md-12">
	                		{this.state.emergency_contact.map((contact, i) => {
	                			return <MultipleEmergencyContact 
	                						key={i} 
	                						index={i} 
	                						totalIndex={this.state.emergency_contact.length}
	                						firstname={contact.firstname} 
	                						lastname={contact.lastname} 
	                						contactNo={contact.emergency_phones[0].contact_no}
	                						numberId={"emergency_contacts[" +i+ "][number]"} 
	                						attrFirstName={"emergency_contacts[" +i+ "][firstname]"}
	                						attrLastName={"emergency_contacts[" +i+ "][lastname]"}
	                						updateEmergencyArray={this.updateEmergencyArray}
	                						addToEmergencyArray={this.addToEmergencyArray}
	                					/>
	                		})}
	                	</div>
	                </div>
	            </div>
	            <div className="form-group">
	            	<div className="row">
	                	
	                </div>
	            </div>
	        </div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/FormCommonFields.js
 **/